module.exports = __webpack_public_path__ + "img/made-in-home2.71f2baa3.jpg";